var React = require('react');

function KbdCapslock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.752 12.605h6.496V16H4.752v-3.395zm.939.967v1.454h4.618v-1.454H5.691zM1.5 6.688L7.996 0 14.5 6.688h-3.252v4.078H4.752V6.688H1.5zm6.496-5.313l-4.313 4.44h2.008v3.977h4.618V5.815h2l-4.313-4.44z"}));
}

KbdCapslock.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdCapslock;

KbdCapslock.default = KbdCapslock;
